import { PayloadAction } from '@reduxjs/toolkit';
import { ThemePack } from '@/types/theme-packs.types';
import { TemplatesReducerCreator } from '../types';

const appendNewThemeReducer = (create: TemplatesReducerCreator) => {
  return create.reducer((state, action: PayloadAction<{ theme: ThemePack; after?: number }>) => {
    if (state.themePacks) {
      if (!action.payload.after) {
        state.themePacks.push(action.payload.theme);
      } else {
        for (let i = 0; i < state.themePacks.length; ++i) {
          const theme = state.themePacks[i];
          if (theme.color_pack === action.payload.after) {
            state.themePacks?.splice(i + 1, 0, action.payload.theme);
            break;
          }
        }
      }
    } else {
      state.themePacks = [action.payload.theme];
    }
  });
};

export default appendNewThemeReducer;
